import React, { ReactNode } from 'react';

import { wsApiUrl } from '@services/EndpointUtil';

import { BaseWebSocketProvider, WebSocketEventHandler } from './BaseWebSocketProvider';

const EVENTS_CONFIG = {
    url: wsApiUrl('/ws/events/'),
    loggerName: 'EventsWebSocket',
    getAuthPayload: (accessToken: string) => ({
        type: 'authenticate',
        Authorization: `Bearer ${accessToken}`,
    }),
};

interface EventsWebSocketProviderProps {
    children: ReactNode;
}

class EventsWebSocket extends BaseWebSocketProvider {
    static useWebSocket() {
        return BaseWebSocketProvider.useWebSocket(EventsWebSocket);
    }
}

export const EventsWebSocketProvider: React.FC<EventsWebSocketProviderProps> = ({ children }) => (
    <EventsWebSocket {...EVENTS_CONFIG} params={{}}>
        {children}
    </EventsWebSocket>
);

// Re-export needed types and hooks
export type { WebSocketEventHandler };
export const useWebSocket = EventsWebSocket.useWebSocket;

export default EventsWebSocketProvider;
